import { localeSchema } from "@garimpa/lib/localeSchema";
import { type ViewerLocale } from "@garimpa/lib/viewerPreferences";

export function routeLocaleFromPathname(pathname: string): ViewerLocale | null {
  const [, localeSegment] = pathname.split("/");
  const locale = localeSchema.safeParse(localeSegment);
  return locale.success ? locale.data : null;
}

export function replaceRouteLocale(pathname: string, nextLocale: ViewerLocale): string | null {
  const currentLocale = routeLocaleFromPathname(pathname);
  if (!currentLocale) return null;
  return pathname.replace(`/${currentLocale}`, `/${nextLocale}`);
}
